<div class="container-fluid p-3">

  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">

          <!-- {{schemeType == 'rev' ? 'CNC Report' :' Sanction Order' }} -->
          <!-- {{ schemeType == 'rev' ? 'CNC Report' : (schemeType == 'tdf' ? 'Development Contract' : 'Sanction Order') }} -->
            <!-- {{schemeType == 'rev'? 'CNC Report': (schemeType == 'tdf'? 'Development Contract' : (schemeType == 'makeI' || schemeType == 'makeII' || schemeType == 'makeIII' ? 'Award of Contract': 'Sanction Order'))}} -->
             {{stepDetails?.name}}


        </h4>
        <h5 class="text-primary">[{{ payload?.proposal_name }}]</h5>
        <div class="status-badge">
          <span class="badge" [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }">
            {{
            stepDetails?.step_status == 0
            ? "INITIATION PENDING"
            : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
        <!-- <button class="btn btn-outline-secondary me-2" (click)="generatePDF()">
          <i class="pi pi-file-pdf me-1"></i> PDF
        </button> -->

        <ng-container *ngIf="stepDetails?.step_status == 'approved'">
          <button class="btn btn-outline-primary me-2" (click)="goToNextStep()">
            Next <i class="pi pi-angle-right ms-1"></i>
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.can_edit || (stepDetails?.step_status != 'approved' && userID == 6)">
          <button (click)="routeConfig.emit({isRouteConfig: true})" 
                  [disabled]="(schemeType === 'tdf' && proposalForm?.invalid) || (schemeType !== 'tdf' && challengeForm?.invalid)"
                  class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>
      
      </div>
    </div>
  </div>

  <hr class="my-3" />
  <p-accordion [multiple]="false" class="custom-accordian" *ngIf="schemeType !='makeI' || schemeType !='makeIII'">
    <p-accordionTab *ngFor="let vendor of vendorList" [header]="vendor.name">

      <div *ngFor="let category of categoryList">
        <div *ngIf="vendor.categories[category]?.length > 0" class="mb-4">

          <h5>{{ category }}</h5>

          <!-- TECHNICAL CATEGORIES -->
          <ng-container *ngIf="category === 'Technical Evaluation' || category === 'Technical Negotiation'">
            <p-table [value]="vendor.categories[category]" styleClass="p-datatable-sm">
              <ng-template pTemplate="header">
                <tr>
                  <th>Document</th>
                  <th>View</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row let-i="rowIndex">
                <tr>
                  <td>{{ row.criteria?.name || 'File ' + (i + 1) }}</td>
                  <td>
                    <a *ngIf="row.document || row.file || row.bid_document"
                      [href]="apiUrl + (row.document || row.file || row.bid_document)" target="_blank">
                      <i class="pi pi-eye"></i>
                    </a>
                  </td>
                </tr>
                <tr *ngIf="schemeType == 'tdf'">
                  <td>Bid Document </td>
                  <td>
                    <a *ngIf=" row.bid_document" [href]="apiUrl + row.bid_document" target="_blank">
                      <i class="pi pi-eye"></i>
                    </a>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </ng-container>

          <!-- FINANCIAL EVALUATION -->
          <ng-container *ngIf="category === 'Financial Evaluation'">
            <p-table [value]="vendor.categories[category]" styleClass="p-datatable-sm">
              <ng-template pTemplate="header">
                <tr>
                  <!-- <th>Vendor Name</th> -->
                  <th>{{schemeType == 'rev' ? 'Cost' :' Budgetary Quote' }}</th>
                  <th>Level</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr>
                  <!-- <td>{{ row.vendor?.name }}</td> -->
                  <td>{{ row.benchmark_price || row.budgetory_quote || '-' }}</td>
                  <td>{{ row.level || '-' }}</td>
                </tr>
              </ng-template>
            </p-table>
          </ng-container>

          <!-- COMMERCIAL NEGOTIATION -->
          <ng-container *ngIf="category === 'Commercial Negotiation'">
            <p-table [value]="vendor.categories[category]" styleClass="p-datatable-sm">
              <ng-template pTemplate="header">
                <tr>
                  <!-- <th>Vendor Name</th> -->
                  <th> {{schemeType == 'rev' ? 'Cost' :' Budgetary Quote' }}</th>
                  <th>Final Price</th>
                  <th>Level</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr>
                  <!-- <td>{{ row.vendor?.name }}</td> -->
                  <td>{{ row.budgetary_quote || row.benchmark_price || row.budgetory_quote || '-' }}</td>
                  <td>{{ row.final_price || '-' }}</td>
                  <td>{{ row.level || '-' }}</td>
                </tr>
              </ng-template>
            </p-table>
          </ng-container>
        </div>
      </div>
    </p-accordionTab>
  </p-accordion>


  <form [formGroup]="commentForm" class="proposal-form-container">
    <div class="form-container">
      <!-- === Collapsible Section Template Example === -->
      <div class="form-section" *ngIf="schemeType === 'rev'">
        <div class="section-header" (click)="toggleSection('basicInfo')">
          <h3 class="section-title">
            Financial Information
            <i class="pi" [ngClass]="expandedSections['basicInfo'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
          </h3>
        </div>
        <div class="section-content" *ngIf="expandedSections['basicInfo']">
          <div class="form-grid">
              <div class="form-field full-width">
                <label for="concurrence_date">Financial Concurrence Date <span class="text-warning">*</span></label>
                <input type="date" pInputText id="concurrence_date" formControlName="concurrence_date" autocomplete="off" [disabled]="isEditorDisabled"/>
              </div>
              <div class="form-field full-width">
                <label for="cfa_date">Final Approval Date<span class="text-warning">*</span></label>
                <input type="date" pInputText id="cfa_date" formControlName="cfa_date" autocomplete="off" [disabled]="isEditorDisabled"/>
              </div>
              <div class="form-field full-width" *ngIf="schemeType === 'rev'">
                <label for="order_date">Sanction Order Date<span class="text-warning">*</span></label>
                <input type="date" pInputText id="order_date" formControlName="order_date" autocomplete="off" [disabled]="isEditorDisabled"/>
              </div>
              <div class="form-field full-width" *ngIf="schemeType === 'rev'">
                <label for="conclusion_date">Contract Conclusion Date<span class="text-warning">*</span></label>
                <input type="date" pInputText id="conclusion_date" formControlName="conclusion_date" autocomplete="off" [disabled]="isEditorDisabled"/>
              </div>
          </div>
        </div>
      </div>
       <!-- === File Upload Section === -->
      <div class="p-3">
        <h3 class="section-title">Document Uploads</h3>
        <!-- Document Upload Table -->
          <app-upload-document [isEditable]="stepDetails?.can_edit"></app-upload-document>
        

        <!-- File Uploads Section -->
        
      </div>
      <!-- === Rich Text Editors Section === -->
      <!-- <div class="editor-field" [class.readonly-editor]="isEditorDisabled">
        
         <p class="bg-primary text-white p-2 ">{{schemeType == 'rev' ? 'CNC Report' : (schemeType == 'makeI' || schemeType == 'makeII' || schemeType == 'makeIII' ? 'Comment' : 'Draft RFP')}}
</p>

        <editor [init]="init" formControlName="sanction_order" [disabled]="isEditorDisabled"></editor>
      </div> -->
       <div class="editor-field" [class.readonly-editor]="isEditorDisabled" *ngIf="schemeType != 'rev'">
        <!-- <p class="bg-primary text-white p-2 ">{{schemeType == 'rev' ? 'CNC Report' :'Draft RFP' }}</p> -->
         <p class="bg-primary text-white p-2 ">{{schemeType == 'makeI' || schemeType == 'makeII' || schemeType == 'makeIII' ? 'Comment' : 'Draft RFP'}}
</p>

        <editor [init]="init" formControlName="sanction_order" [disabled]="isEditorDisabled"></editor>
      </div>

     
    </div>
   
 

    <!-- <p-button label="Submit" icon="pi pi-save" (click)="onSubmit()" [disabled]="commentForm.invalid" [outlined]="true" type="submit"></p-button> -->
  </form>

  

</div>